import { Box, Group, Skeleton, Text, Tooltip } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import { getSyleColors } from 'services/styleService';
import { logger } from 'utils/logger';

const rgbToHex = (r, g, b) => {
    return (
        '#' +
        [r, g, b]
            .map((x) => {
                const hex = parseInt(x).toString(16);
                return hex.length === 1 ? '0' + hex : hex;
            })
            .join('')
    );
};

const ColorSwatch = ({ colors = [], size = 20, autoWidth = false, showTooltip = true, spacing = 0, styleId, doFetch = false, placeholder = 'No colours available' }) => {
    const [fetchedColors, setFetchedColors] = useState([]);
    const [loading, setLoading] = useState(colors.length === 0 ? true : false);

    useEffect(() => {
        const fetchColors = async () => {
            if (doFetch && styleId) {
                setFetchedColors([]); // Clear previous colors immediately
                setLoading(true);
                try {
                    const styleColors = await getSyleColors(styleId);
                    logger.log(styleColors, 'styleColors');
                    setFetchedColors(styleColors);
                } catch (error) {
                    console.error('Error fetching style colors:', error);
                } finally {
                    setLoading(false);
                }
            }
        };
        setFetchedColors([]);
        fetchColors();
    }, [doFetch, styleId]);

    // Use fetched colors if available, otherwise use the colors prop
    const displayColors = fetchedColors.length > 0 ? fetchedColors : colors;

    if (displayColors && displayColors.length === 0 && !loading) {
        return (
            <Text color='dimmed' size={'sm'}>
                {placeholder}
            </Text>
            // <Box
            //     sx={(theme) => ({
            //         width: size,
            //         height: size,
            //         borderRadius: theme.radius.sm,
            //         backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[1],
            //         border: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[3]}`,
            //     })}
            // />
        );
    }

    return (
        <>
            {loading ? <Skeleton border={0} height={size} width={100} /> : 
            <Group spacing={spacing} style={{ width: autoWidth ? '100%' : 'auto' }} grow={autoWidth}>
                {displayColors.map((color, index) => {
                    const hexColor = color?.r && color?.g && color?.b ? rgbToHex(color.r, color.g, color.b) : '#efefef';

                    const swatch = (
                        <Box
                            key={index}
                            sx={(theme) => ({
                                width: size,
                                height: size,
                                borderRadius: index === 0 ? '3px 0 0 3px' : index === displayColors.length - 1 ? '0 3px 3px 0' : '0',
                                backgroundColor: hexColor,
                                // border: `1px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
                                cursor: 'pointer',
                                marginLeft: index === 0 ? 0 : -1,
                            })}
                        />
                    );

                    if (showTooltip) {
                        return (
                            <Tooltip key={index} label={hexColor}>
                                {swatch}
                            </Tooltip>
                        );
                    }

                    return swatch;
                })}
            </Group>
            }
        </>
    );
};

export default ColorSwatch;
